import { LoadingSkeleton, tokens } from 'ComponentLibrary'
import { Stack } from '@mui/material'
import { PageGridContainer, PageGridItem } from 'ComponentLibrary/src/piazza/grid/PageGrid'
import { Headline } from 'ComponentLibrary/src/piazza/text/Headline/Headline'
import { DashboardBackground } from 'ClientPortal/src/pages/Dashboard/DashboardBackground'
import { useTranslation } from 'react-i18next'

export function DashboardLoading() {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })

    return (
        <>
            <DashboardBackground />
            <PageGridContainer withBottomSpace withTopSpace withFooter>
                <PageGridItem columnSpan={6} columnSpanXs={4}>
                    <Headline title={tCommon('overview')} variant="headline1" />
                </PageGridItem>
                <PageGridItem columnSpan={6} columnSpanXs={4}>
                    <LoadingSkeleton height="317px" width="100%" sx={{ transform: 'none' }} />
                </PageGridItem>
                <PageGridItem columnSpan={3} columnSpanXs={4}>
                    <Stack direction="column" gap={tokens.SizingSpacing300}>
                        <Stack direction="row" gap={tokens.SizingSpacing300}>
                            <LoadingSkeleton count={2} height="120px" width="100%" sx={{ transform: 'none' }} />
                        </Stack>
                        <Stack direction="row" gap={tokens.SizingSpacing300}>
                            <LoadingSkeleton count={2} height="120px" width="100%" sx={{ transform: 'none' }} />
                        </Stack>
                    </Stack>
                </PageGridItem>
                <PageGridItem columnSpan={3} columnSpanXs={4}>
                    <LoadingSkeleton height="264px" sx={{ transform: 'none' }} />
                </PageGridItem>
                <PageGridItem columnSpan={6} columnSpanXs={4}>
                    <Stack direction="row" gap={tokens.SizingSpacing300}>
                        <LoadingSkeleton count={3} height="120px" width="100%" sx={{ transform: 'none' }} />
                    </Stack>
                </PageGridItem>
                <PageGridItem columnSpan={3} columnSpanXs={4}>
                    <LoadingSkeleton height="404px" width="100%" sx={{ transform: 'none' }} />
                </PageGridItem>
                <PageGridItem columnSpan={3} columnSpanXs={4}>
                    <LoadingSkeleton height="404px" width="100%" sx={{ transform: 'none' }} />
                </PageGridItem>
            </PageGridContainer>
        </>
    )
}
